import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { AppButton } from '../../Components/index.js'
import { useStyles } from './style.js'

const Error403 = (props) => {
  const classes = useStyles()
  const history = useHistory()
  return (
    <div className={classes.headerWrapper}>
      <div className={classes.title}>403</div>
      <div className={classes.content}>You do not have permission to access this page.</div>
      <AppButton text="Go to Home" onClick={() => history.push(props.isSuperAdmin || props.currentUser && props.currentUser.gsmAccess === 'true' ? '/dashboard' : '/developer')} />
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(Error403)